import { clamp, Easing } from '@/lib/anim/easing';

import { EMAIL_BODY, T } from './storyboard';

// Ch. 05 - voice: a draft composer with the body typing itself out.
export function Scene5Voice({ time }: { time: number }) {
  const [start, end] = T.voice;
  if (time < start || time > end) return null;
  const localTime = time - start;
  const duration = end - start;

  const inT = Easing.easeOutCubic(clamp(localTime / 0.55, 0, 1));
  const outT = clamp((localTime - (duration - 0.5)) / 0.5, 0, 1);
  const opacity = inT * (1 - outT);

  return (
    <>
      <div
        style={{
          position: 'absolute',
          left: 0,
          right: 0,
          top: 110,
          textAlign: 'center',
          opacity,
          transform: `translateY(${(1 - inT) * 14}px)`,
          zIndex: 2,
        }}
      >
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 14, marginBottom: 18 }}>
          <span style={{ width: 32, height: 1, background: 'var(--assay-ore)' }} />
          <span
            style={{
              fontFamily: '"DM Mono", monospace',
              fontSize: 11,
              letterSpacing: '0.26em',
              textTransform: 'uppercase',
              color: 'var(--assay-ore)',
            }}
          >
            Ch. 05 - Voice
          </span>
          <span style={{ width: 32, height: 1, background: 'var(--assay-ore)' }} />
        </div>
        <h2
          style={{
            fontFamily: '"Cormorant Garamond", "Georgia", serif',
            fontWeight: 300,
            fontSize: 60,
            lineHeight: 1.05,
            color: 'var(--assay-text-primary)',
            letterSpacing: '-0.02em',
            margin: 0,
          }}
        >
          Messages that <em style={{ color: 'var(--assay-ore-light)' }}>sound like you</em>.
        </h2>
      </div>

      <div
        style={{
          position: 'absolute',
          left: '50%',
          top: '52%',
          transform: `translate(-50%, calc(-50% + ${(1 - inT) * 24}px)) scale(${0.97 + 0.03 * inT})`,
          opacity,
          width: 920,
          background: 'var(--assay-surface)',
          border: '1px solid var(--assay-ore-border-hover)',
          borderRadius: 2,
          boxShadow:
            '0 24px 60px rgba(0,0,0,0.55), 0 0 0 1px rgba(196,152,58,0.12), 0 0 36px rgba(196,152,58,0.08)',
          zIndex: 2,
        }}
      >
        <div
          style={{
            padding: '12px 20px',
            borderBottom: '1px solid var(--assay-ore-border)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            background: 'rgba(196,152,58,0.04)',
          }}
        >
          <span
            style={{
              fontFamily: '"DM Mono", monospace',
              fontSize: 10,
              letterSpacing: '0.22em',
              textTransform: 'uppercase',
              color: 'var(--assay-text-label)',
            }}
          >
            New message · Draft
          </span>
          <span
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              fontFamily: '"DM Mono", monospace',
              fontSize: 10,
              letterSpacing: '0.16em',
              color: 'var(--assay-ore-light)',
            }}
          >
            <span
              style={{
                width: 6,
                height: 6,
                borderRadius: '50%',
                background: 'var(--assay-ore)',
                boxShadow: '0 0 6px var(--assay-ore)',
              }}
            />
            Voice: yours
          </span>
        </div>
        <div
          style={{
            padding: '14px 24px 0',
            fontFamily: '"DM Mono", monospace',
            fontSize: 13,
            color: 'var(--assay-text-body)',
            display: 'flex',
            flexDirection: 'column',
            gap: 6,
          }}
        >
          <div>
            <span
              style={{
                color: 'var(--assay-text-label)',
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                fontSize: 10,
                marginRight: 14,
              }}
            >
              To
            </span>
            <span style={{ color: 'var(--assay-text-primary)' }}>Sarah Park</span>
            <span style={{ color: 'var(--assay-text-muted)', marginLeft: 8 }}>
              · sarah@plate.co
            </span>
            <span
              style={{
                marginLeft: 14,
                fontSize: 9.5,
                letterSpacing: '0.18em',
                textTransform: 'uppercase',
                color: '#e8b84b',
                padding: '3px 8px',
                border: '1px solid rgba(232,184,75,0.4)',
                background: 'rgba(232,184,75,0.08)',
                borderRadius: 2,
              }}
            >
              Contact Now
            </span>
          </div>
          <div>
            <span
              style={{
                color: 'var(--assay-text-label)',
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                fontSize: 10,
                marginRight: 14,
              }}
            >
              Re
            </span>
            <span style={{ color: 'var(--assay-text-primary)' }}>
              A thought from your retention talk
            </span>
          </div>
        </div>
        <div
          style={{
            padding: '20px 24px 24px',
            fontFamily: '"DM Mono", monospace',
            fontSize: 14,
            lineHeight: 1.75,
            color: 'var(--assay-text-body)',
            minHeight: 200,
            borderTop: '1px solid var(--assay-ore-border)',
            marginTop: 14,
          }}
        >
          <TypedText text={EMAIL_BODY} startAt={0.4} localTime={localTime} />
        </div>
        <div
          style={{
            padding: '12px 20px',
            borderTop: '1px solid var(--assay-ore-border)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            background: 'rgba(0,0,0,0.2)',
          }}
        >
          <span
            style={{
              fontFamily: '"DM Mono", monospace',
              fontSize: 10,
              letterSpacing: '0.18em',
              textTransform: 'uppercase',
              color: 'var(--assay-text-label)',
            }}
          >
            Context: 3 notes · Last touch 14d ago
          </span>
          <span
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              padding: '7px 14px',
              background: 'var(--assay-ore)',
              color: '#14110a',
              fontFamily: '"DM Mono", monospace',
              fontSize: 10,
              letterSpacing: '0.18em',
              textTransform: 'uppercase',
              fontWeight: 500,
              borderRadius: 2,
              boxShadow: '0 0 18px rgba(196,152,58,0.4)',
            }}
          >
            Send ›
          </span>
        </div>
      </div>
    </>
  );
}

function TypedText({
  text,
  startAt,
  localTime,
  charsPerSec = 62,
}: {
  text: string;
  startAt: number;
  localTime: number;
  charsPerSec?: number;
}) {
  const elapsed = Math.max(0, localTime - startAt);
  const charsToShow = Math.min(text.length, Math.floor(elapsed * charsPerSec));
  const shown = text.slice(0, charsToShow);
  const showCaret = charsToShow < text.length || Math.floor(localTime * 2) % 2 === 0;
  return (
    <span style={{ whiteSpace: 'pre-wrap' }}>
      {shown}
      <span
        style={{
          display: 'inline-block',
          width: 8,
          height: '1em',
          background: 'var(--assay-ore-light)',
          verticalAlign: 'text-bottom',
          marginLeft: 1,
          opacity: showCaret ? 1 : 0,
          boxShadow: '0 0 6px rgba(232,184,75,0.6)',
        }}
      />
    </span>
  );
}
